import React, { Fragment } from 'react';

// Import Design System
import '../../styles/design-system.scss';

// Import Modern Components
import ModernHeader from '../../components/header/ModernHeader';
import ModernHero from '../../components/hero/ModernHero';
import ModernPartners from '../../components/partners/ModernPartners';
import ModernAbout from '../../components/about/ModernAbout';
import ModernServices from '../../components/Services/ModernServices';
import HowWeWork from '../../components/HowWeWork/HowWeWork';
import ModernIndustries from '../../components/Industries/ModernIndustries';
import CertificationsTrust from '../../components/CertificationsTrust/CertificationsTrust';
import ModernTestimonials from '../../components/Testimonials/ModernTestimonials';
import FaqSection from '../../components/FaqSection/FaqSection';
import ModernCTA from '../../components/CTA/ModernCTA';
import ModernFooter from '../../components/footer/ModernFooter';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';

// Import Global Styles
import './ModernHomePage.scss';

const ModernHomePage = () => {
    return (
        <Fragment>
            <div className="jk-app">
                <ModernHeader />
                <main className="jk-main">
                    <ModernHero />
                    <ModernPartners />
                    <ModernAbout />
                    <ModernServices />
                    <HowWeWork />
                    <CertificationsTrust />
                    <ModernIndustries />
                    <ModernTestimonials />
                    <FaqSection />
                    <ModernCTA />
                </main>
                <ModernFooter />
                <ScrollToTop />
            </div>
        </Fragment>
    );
};

export default ModernHomePage;
